import React from "react";

const CARD_PALETTE: Record<string, { innerGlow: string; gradStart: string; dropShadow: string }> = {
  ultra: { innerGlow: "#FFBF00", gradStart: "#442800", dropShadow: "#FFA629" },
  rare: { innerGlow: "#0084FF", gradStart: "#001351", dropShadow: "#0084FF" },
  epic: { innerGlow: "#CC23FF", gradStart: "#3E0060", dropShadow: "#A855F7" },
  commun: { innerGlow: "#ffffff69", gradStart: "#1C2030", dropShadow: "#6B7A8F" },
};

const CARD_PATH =
  "M0 33.4184C0 19.6437 10.0086 7.97071 23.6934 6.39966C47.8391 3.62769 88.1094 -1.18922e-09 133.5 0C178.729 1.185e-09 218.496 3.60198 242.378 6.37011C256.034 7.95288 266 19.6082 266 33.3552V317.707C266 331.179 257.02 342.999 244.041 346.609L140.504 375.413C135.595 376.778 130.405 376.778 125.496 375.412L21.9595 346.609C8.98044 342.999 0 331.179 0 317.707V33.4184Z";

export function CardShape({ rarity, uid }: { rarity: string; uid: string }) {
  const pal = CARD_PALETTE[rarity] ?? CARD_PALETTE.commun;
  const fId = `innerGlow_${uid}`;
  const clipId = `clip_${uid}`;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 266 377"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "block",
        // L'ombre externe : blur de 208px selon tes specs Figma (attention, c'est énorme, l'aura va déborder de partout)
filter: `drop-shadow(0px 0px 80px ${pal.dropShadow}AA)`,      }}
    >
      <defs>
        <clipPath id={clipId}>
          <path d={CARD_PATH} />
        </clipPath>

        {/* Lueur interne stricte selon ta capture : Y=1, Blur=0 */}
        <filter id={fId} x="-10%" y="-10%" width="120%" height="120%">
          <feOffset dx="0" dy="1" result="offset" />
          <feComposite operator="out" in="SourceGraphic" in2="offset" result="inverse" />
          <feFlood floodColor={pal.innerGlow} floodOpacity="1" result="color" />
          <feComposite operator="in" in="color" in2="inverse" />
        </filter>
      </defs>

      <foreignObject width="266" height="377" clipPath={`url(#${clipId})`}>
        <div
          style={{
            width: "100%",
            height: "100%",
            background: `radial-gradient(circle at 50% 0%, ${pal.gradStart} 0%, #000000 80%)`,
            backgroundColor: "#000000",
          }}
        />
      </foreignObject>

      <path d={CARD_PATH} fill="#FFF" filter={`url(#${fId})`} />
    </svg>
  );
}